import React, { useState, useEffect } from "react";
import moviesData from "./moviesData/movies";
import MovieCard from "./components/movieCard";
import "./styles.css";

function App() {
  const [search, setSearch] = useState("");
  const [favorites, setFavorites] = useState([]);
  const [selectedTrailer, setSelectedTrailer] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  // load favorites
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(saved);
  }, []);

  // save favorites
  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  const toggleFavorite = (title) => {
    setFavorites((prev) =>
      prev.includes(title)
        ? prev.filter((t) => t !== title)
        : [...prev, title]
    );
  };

  const filteredMovies = moviesData.filter((movie) =>
    movie.title.toLowerCase().includes(search.toLowerCase())
  );

  const favoriteMovies = moviesData.filter((m) =>
    favorites.includes(m.title)
  );

  return (
    <div className="app">

      {/* ===== NAVBAR ===== */}
      <div className="navbar">
        <h2 className="logo">🎬 LetsNet</h2>

        <input
          className="nav-search"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="profile" onClick={() => setMenuOpen(!menuOpen)}>
          👤
          {menuOpen && (
            <div className="dropdown">
              <p>Profile</p>
              <p>Settings</p>
              <p>Help</p>
              <p>Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* ===== FAVORITES ROW ===== */}
      {favoriteMovies.length > 0 && (
        <div className="row">
          <h2>❤️ Your Favorites</h2>
          <div className="row-movies">
            {favoriteMovies.map((movie, index) => (
              <MovieCard
                key={index}
                movie={movie}
                isFavorite={true}
                toggleFavorite={toggleFavorite}
                openTrailer={setSelectedTrailer}
              />
            ))}
          </div>
        </div>
      )}

      {/* ===== MAIN MOVIES ROW ===== */}
      <div className="row">
        <h2>🔥 Movies</h2>
        <div className="row-movies">
          {filteredMovies.map((movie, index) => (
            <MovieCard
              key={index}
              movie={movie}
              isFavorite={favorites.includes(movie.title)}
              toggleFavorite={toggleFavorite}
              openTrailer={setSelectedTrailer}
            />
          ))}
        </div>
      </div>

      {/* 🎥 TRAILER MODAL */}
      {selectedTrailer && (
        <div className="modal" onClick={() => setSelectedTrailer(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={selectedTrailer}
              title="Trailer"
              allowFullScreen
            ></iframe>
            <button onClick={() => setSelectedTrailer(null)}>
              ❌ Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;